import Vue from "vue";
import Vuex from "vuex";
import options from "./filters/filters";
// import sortering from "./sortering/sortering";
// import wonenObjecten from "./wonenObjecten/wonenObjecten";
import miscData from "./miscData/miscData"
import carousels from "./carousels/carousels"
import products from "./products/products";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    showProductBoard: true, // dit kan je ook gebruiken als je respectievelijk aan het ProductBoard of MapsBoard wil werken.
    routedByRedirection: false,
    sortBy: "",
  },
  getters: {
    // dataReady: function(state) {
    //   return state.miscData.miscDataReady && state.wonenObjecten.wonenObjectenDataReady ? true : false;
    // },
  },
  mutations: {
    showProductBoard(state, payload) {
      state.showProductBoard = payload;
    },
    routedByRedirection(state, payload) {
      state.routedByRedirection = payload;
    },
  },
  actions: {},
  modules: {
    // filters: filters,
    // wonenObjecten: wonenObjecten,
    miscData: miscData,
    carousels: carousels,
    products: products,
    // sortering: sortering
  },
});
